// Stats WhatsApp (pikachu « WhatsApp › Stats ») : formats et libellés.

export const ENTRY_LABELS = { site: "Site", alert: "Alertes", qr: "QR code", instagram: "Instagram", email: "Emails", direct: "Direct" };
export const FAMILY_LABELS = { advisor: "Conseiller", alerts: "Alertes", campaigns: "Campagnes", other: "Autres" };
export const PLACEMENT_LABELS = {
    chatbot: "Chatbot", grid_tile: "Tuile des listes", search_tile: "Tuile de recherche", landing: "Page /whatsapp",
    optin_landing: "Bons plans (page)", optin_account: "Bons plans (compte)", alert_choice_price: "Alerte prix", alert_choice_size: "Alerte taille",
};

// delta : évolution d'une paire {current, previous} ; « — » quand la période précédente est nulle.
export function delta(pair) {
    if (!pair || !pair.previous) return { label: "—", up: null };
    // valeur absolue au dénominateur : une marge qui passe de −5 € à +10 € est une hausse, pas « −300 % »
    const v = Math.round(((pair.current - pair.previous) / Math.abs(pair.previous)) * 100);
    return { label: (v >= 0 ? "+" : "−") + Math.abs(v) + " %", up: v >= 0 };
}

export function eur(n) {
    const v = Number(n) || 0;
    const digits = Math.abs(v) < 10 ? 2 : 0;
    return v.toLocaleString("fr-FR", { minimumFractionDigits: digits, maximumFractionDigits: digits }).replace(/ | /g, " ") + " €";
}

export function pct(n, total) {
    if (!total) return "—";
    return Math.round((n / total) * 100) + " %";
}

// comparableCost : coût et marge ne se comparent qu'entre périodes où le coût Meta est suivi (sinon la
// « hausse » viendrait du démarrage du suivi, pas d'une vraie dépense).
export function comparableCost(cost) {
    return !!cost && !cost.previous.metaPartial;
}
